module.exports = __webpack_public_path__ + "img/p6.15b932a2.png";